import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const queryFn = (accessToken: string, propertyUid: string) =>
    fetch(`${BACKEND_DOMAIN}/properties/${propertyUid}`, {
        method: "GET",
        headers: buildRequestHeaders(accessToken),
    }).then((res) => {
        if (!res.ok) throw new Error(`Error ${res.status}`);
        return res.json();
    });

export default queryFn;
